/**
 * @author Kuitos
 * @since 2020-02-21
 */
export { addErrorHandler, removeErrorHandler } from 'single-spa';
export function addGlobalUncaughtErrorHandler(errorHandler) {
  window.addEventListener('error', errorHandler);
  window.addEventListener('unhandledrejection', errorHandler);
}
export function removeGlobalUncaughtErrorHandler(errorHandler) {
  window.removeEventListener('error', errorHandler);
  window.removeEventListener('unhandledrejection', errorHandler);
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/qiankun/es/errorHandler.js
// module id = 618
// module chunks = 0